import { Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { Motif } from '@/app/shared/enums/motif-enum';
import { useAlertStore } from '@/app/shared/stores/alert-store';
import { ListEvents } from '../types/list-events.interface';

export default function useCopyForm<T extends ListEvents<U>, U>(
  gridApi: Ref<GridApi | null>,
  module: string,
  emit: T
) {
  const { t } = useI18n();
  const alertStore = useAlertStore();

  const openCopyForm = () => {
    const rows = gridApi.value?.getSelectedRows() ?? [];
    if (rows.length === 0) {
      return alertStore.showNotification(
        t('filtersNotSelected'),
        t(module),
        Motif.ERROR
      );
    }

    if (rows.length > 1) {
      return alertStore.showNotification(
        t('filtersSelected'),
        t(module),
        Motif.ERROR
      );
    }
    emit('copy', rows.shift());
    gridApi.value?.deselectAll();
  };

  return {
    openCopyForm,
  };
}
